var map = {
	"./SvgIcon.vue": "0032",
	"./charts/Bar.vue": "b930",
	"./charts/Pie.vue": "9a28",
	"./charts/Scatter.vue": "b9f1",
	"./chat/addGroup.vue": "843a",
	"./chat/chatBox1.vue": "1ba5",
	"./chat/groupMempers.vue": "5c69",
	"./chat/inviteStudent.vue": "4c25",
	"./com.vue": "3199",
	"./confirmActionDialog.vue": "f656",
	"./custom-file-uploader.vue": "7339",
	"./custom-html-editor.vue": "1adb",
	"./dataTime.vue": "ef19",
	"./degrees/degreesImportFromXlsx.vue": "c7ac",
	"./downloadFile.vue": "41d7",
	"./emoji.vue": "4b72",
	"./exams/addExam.vue": "b279",
	"./exams/addQuestion.vue": "9b54",
	"./exams/addStudentToExam.vue": "e133",
	"./exams/checkExamQuestion.vue": "3b08",
	"./exams/examAnalytics/difficulty.vue": "4006",
	"./exams/examAnalytics/discrimination.vue": "a6a9",
	"./exams/examAnalytics/examAnalytics.vue": "d10ff",
	"./exams/examAnalytics/internalValidity.vue": "6bf0",
	"./exams/examAnalytics/reliability.vue": "66af",
	"./exams/examSettings.vue": "9349",
	"./exams/examStatistics.vue": "6265",
	"./exams/question.vue": "a464",
	"./exams/questionTitle.vue": "5c17",
	"./exams/showQuestion.vue": "7563",
	"./exams/showStudentRes.vue": "df13",
	"./exams/studentsResult.vue": "0df2",
	"./exams/timer.vue": "f8c1",
	"./export-json-excel.vue": "3d52",
	"./faceId-camera.vue": "dad5",
	"./fileFiled.vue": "f08f",
	"./filesIcon.vue": "7a71",
	"./forums/forumItemsList.vue": "5a4d",
	"./forums/forumsLayout.vue": "3f92",
	"./forums/topicContentList.vue": "ea1c",
	"./forums/topicContentRatesFeedbacks.vue": "fbd9",
	"./forums/topicContentReplies.vue": "d38d",
	"./forums/topicContentReplyItem.vue": "5ee6",
	"./loadingData.vue": "d74f",
	"./loadingScreen.vue": "6042",
	"./mails/replyMail.vue": "18f3",
	"./mails/sendMail.vue": "fc86",
	"./noData.vue": "6a2b",
	"./portfolio/TagsItem/tagItemDialog.vue": "1630",
	"./portfolio/achievements/achievementsDialog.vue": "6981",
	"./portfolio/baseCard.vue": "52e6",
	"./portfolio/comments/comments.vue": "eb81",
	"./portfolio/comments/commentsDialog.vue": "a572",
	"./portfolio/feedback/feedbackDialog.vue": "b0f6",
	"./portfolio/feedback/feedbacks.vue": "debb",
	"./portfolio/goals/goalsDialog.vue": "eb9f",
	"./portfolio/infoSection.vue": "b597",
	"./portfolio/portfolioCard.vue": "2c2a",
	"./portfolio/profileImage.vue": "3d86",
	"./portfolio/reflection/reflectionsDialog.vue": "677f",
	"./portfolio/searchTextfield.vue": "f5ff",
	"./portfolio/summarySection.vue": "971c",
	"./portfolio/tagsMini.vue": "a92b",
	"./portfolio/workSample/worksampleDialog.vue": "6d34",
	"./timePicker.vue": "ec79"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ffe0";